<div role="group" aria-labelledby="remove filters">
	<button
		cdxButton
		fillStyle="secondaryOutline"
		endSlotSize="extra-small"
		[endSlotActive]="true"
		*ngFor="let filter of filters"
		(click)="onRemoveFilter(filter)"
		class="filterButton"
		[attr.aria-label]="'remove ' + filter.name + ' filter'"
	>
		{{ filter.name }}
		<cdx-svg-icon name="cross" size="extra-small" fill="dark" end></cdx-svg-icon>
	</button>
	<button cdxButton fillStyle="flat" class="clearAllButton" (click)="onRemoveAllFilters()" [attr.aria-label]="'Clear all filters'">
		Clear Filters
	</button>
</div>
